import React from "react";

import { confirmPayment } from "../modules/refill/confirmPayment";

import { ConfirmOrderActionPage } from "./ConfirmOrderActionPage";

export const ConfirmPaymentPage = () => (
  <ConfirmOrderActionPage
    apiCall={confirmPayment}
    successToast="Thanks — we've recorded your payment"
    loadingText="Recording payment..."
  />
);
